import {useState, useEffect} from 'react';
import RED_API from "../network/redAPI";

export const usePayment = () => {
	const [listPaymentMethod, setListPaymentMethod] = useState([]);
	const [kessPayment, setKessPayment] = useState([]);
	const [isPaymentRequesting, setIsPaymentRequesting] = useState(false);
	const addFallbackMethods = (existingMethods, fallbackMethods) => {
		const existingBICs = new Set(existingMethods.map((m) => m.bic));
		const filteredFallbacks = fallbackMethods.filter(
			(fallback) => !existingBICs.has(fallback.bic)
		);

		const updatedList = [...existingMethods];
		for (let method of filteredFallbacks) {
			updatedList.splice(1, 0, {
				...method,
				bic: "ABA_PAY",
				id: updatedList.length,
			});
		}
		return updatedList;
	};

	const fetchPaymentMethods = async () => {
		setIsPaymentRequesting(true);
		try {
			const response = await RED_API.PaymentGateWay({
				service: 'webpay.acquire.getpaymentmethods',
			});
			const res = await response.json();
			const paymentData = res?.data?.data || [];

			setKessPayment(paymentData.map((method) => method.bic));

			// Try fetching fallback payment methods (ABA etc)
			let fallbackMethods = [];
			try {
				const fallbackResponse = await RED_API.getPaymentMethods();
				const fallbackData = await fallbackResponse.json();
				fallbackMethods = (fallbackData || []).map((item) => ({
					title: item.name || 'Unnamed',
					img_url: item.logo,
					bic: item.bic,
					storelink: {ios: null, android: null},
				}));
			} catch {
				setListPaymentMethod(paymentData);
				return;
			}

			// Try to add fallback methods; if error occurs, just return paymentData
			let updatedList;
			try {
				updatedList = addFallbackMethods(paymentData, fallbackMethods);
			} catch {
				setListPaymentMethod(paymentData);
				return;
			}

			setListPaymentMethod(updatedList);
		} catch (error) {
			console.error('Error fetching payment methods:', error);
		} finally {
			setIsPaymentRequesting(false);
		}
	}

	return {
		listPaymentMethod,
		kessPayment,
		isPaymentRequesting,
		fetchPaymentMethods,
		addFallbackMethods,

	};
};
